import {
	ADDITIONAL_PROPERTY_FLAG,
	FormContextType,
	RJSFSchema,
	StrictRJSFSchema,
	TranslatableString,
	WrapIfAdditionalTemplateProps,
} from '@rjsf/utils';

function WrapIfAdditionalTemplate<T = any, S extends StrictRJSFSchema = RJSFSchema, F extends FormContextType = any>(
	props: WrapIfAdditionalTemplateProps<T, S, F>
) {
	const {
		children,
		label,
		registry,
		schema,
	} = props;
	const { templates, translateString } = registry;

	const { RemoveButton } = templates.ButtonTemplates;
	const keyLabel = translateString(TranslatableString.KeyLabel, [label]);
	const additional = ADDITIONAL_PROPERTY_FLAG in schema;

	if (!additional) {
		return children;
	}

	return (
		<div data-role="WrapIfAdditionalTemplate" style={{ display: 'flex', flexDirection: 'row' }}>
			{children}
		</div>
	);
}

export { WrapIfAdditionalTemplate };
